import '@/styles/ui.css'
import '@/styles/main.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import bus from './bus'
import { i18n } from './i18n'
import { path } from 'ramda'
import './components'
import './tracking'
import { WaitUntil, Capitalize } from '@/utils'

String.prototype.toTitleCase = function () {
  return Capitalize(this)
}

import VTooltip from 'v-tooltip'
Vue.use(VTooltip, {
  defaultHideOnTargetClick: false,
  defaultOffset: 5,
  defaultDelay: 300,
})

import { Auth0Plugin } from './auth'

Vue.config.productionTip = false
Vue.config.ignoredElements = [/kvass-\w*/]

import AutoAnimate from '@/directives/autoanimate'
Vue.directive('auto-animate', AutoAnimate)

Vue.prototype.$bus = bus
Vue.prototype.$body = document.body

Vue.prototype.$path = function () {
  let [key, obj, ...args] = arguments

  key = typeof key === 'string' ? key.split('.') : key
  obj = obj || this

  return path.apply(this, [key, obj, ...args])
}

Vue.prototype.$glob = function (value, pattern) {
  pattern = typeof pattern === 'string' ? pattern.split(' ') : pattern

  let inclusions = pattern.filter(p => !p.startsWith('!'))
  let exclusions = pattern.filter(p => p.startsWith('!')).map(p => p.substring(1))

  if (inclusions.length) return inclusions.includes(value)
  return !exclusions.includes(value)
}

bus.$on('chat', async message => {
  if (!Intercom) return

  Intercom('showNewMessage', message)
  let btn

  await WaitUntil(() => {
    try {
      btn = document
        .querySelector('.intercom-app iframe')
        .contentWindow.document.querySelector('.intercom-composer-send-button')
      if (btn) return true
    } catch (err) {}
  })

  if (btn) btn.click()
})

Vue.use(Auth0Plugin, {
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientId: process.env.VUE_APP_AUTH0_CLIENTID,
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
